/* eslint-disable max-len */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Grid, IconButton, useTheme } from '@material-ui/core';
import { useHistory, useParams } from 'react-router-dom';
import { AutoCompleteWithCategories } from 'commons/AutoComplete/AutoCompleteWithCategories';
import CustomIcon from 'commons/Icon/CustomIcon';
import { faTimes } from '@fortawesome/pro-solid-svg-icons';
import { ProductService } from 'services/ProductService';
import { ProductTestService } from 'services/ProductTestService';
import { DialogType } from 'commons/Dialog/CustomDialog';
import { localize } from 'commons/LocalizedText/LocalizedText';
import { GENERATE_ROUTE, ROUTES } from 'utils/constants/routes';
import { useDialog } from 'hook/DialogProvider';
import { ErrorName } from 'utils/constants/error.name';

const useStyles = makeStyles((theme) => ({
  container:{
    height: '100%',
    paddingRight: '5%'
  },
  closeIcon: {
    position: "absolute" ,
    top: -5,
    right: 0
  },
  searchBar: {
    width: 500,
    marginTop: 10,
    marginBottom: 10,
    "& .MuiFormControl-root": {
      marginTop: 0
    },
    '& .MuiAutocomplete-inputRoot': {
      color: theme.palette.primary.light
    },
    '& .MuiInputLabel-animated':{
      color: theme.palette.primary.light
    },
    '& .MuiAutocomplete-endAdornment':{
      color: theme.palette.primary.light
    },
    '& .MuiIconButton-label':{
      color: theme.palette.primary.light
    },
    '& .MuiInput-underline:before':{
      borderBottom: `1px solid ${theme.palette.primary.light}`
    }
  }
}));

const SearchBar = ({setDisplaySearch}) => {
  const classes = useStyles();
  const showDialog = useDialog();
  const history = useHistory();
  const [selectedItem, setSelectedItem] = useState(null);
  const [productOptions, setProductOptions] = useState([
    {label: 'searchToolTip', isSubTitle: true}
  ]);
  const [productTestOptions, setProductTestOptions] = useState([
    {label: 'searchToolTip', isSubTitle: true}
  ]);
  // const [auditOptions, setAuditOptions] = useState([
  //   {label: 'searchToolTip', isSubTitle: true}
  // ]);
  const [itemOptions, setItemOptions] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [searchString, setSearchString] = useState('');
  const theme = useTheme();
  const previousController = useRef();

  const { laboratory: laboratoryId } = useParams();

  const handleSelectItem = item => {
    if(item) {
      setDisplaySearch(false);
      const laboratory = laboratoryId ?? item.laboratoryRecid;
      if(item.productNumber){
        setSelectedItem(item.recid);
        history.push(
          `${GENERATE_ROUTE(ROUTES.TESTS, { laboratory: laboratory })}?productNumber=${item.productNumber}`
        );
      }else{
        setSelectedItem(item.productTestLaboDetailsRecid);
        history.push(GENERATE_ROUTE(ROUTES.TEST.BASE,
          { laboratory: laboratory, ptldId: item.productTestLaboDetailsRecid }
        ));
      }
    }
  }

  const setOptions = (requestResult, setValues, values) => {
    if(!values[values.length - 1]?.isTitle){
      values.pop();
    }
    if(requestResult.length === 0){
      setValues([{
        label: 'noOption',
        isSubTitle: true
      }]);
    }else{
      setValues([...requestResult]);
    }
  }

  const isThereMutlipleProduct = (product, array) => {
    return array.filter(prod => prod.name === product.name).length > 1;
  }

  const handleChangeTextField = value => {
    if (previousController.current) {
      previousController.current.abort();
    }
    const controller = new AbortController();
    const { signal } = controller;
    previousController.current = controller;
    const searchStringTmp = value;
    setSearchString(searchStringTmp);
    if(searchStringTmp.length >= 4){
      setIsLoading(true);
      const productsPromise = ProductService.getProductsByNameAndNumber({searchString: searchStringTmp, laboratoryRecid: laboratoryId}, signal);
      const productTestsPromise = ProductTestService.getProductTestsByTestNumber({searchString: searchStringTmp, laboratoryRecid: laboratoryId}, signal);
      //const auditsPromise = AuditService.getAuditssByName(laboratoryId, searchStringTmp, signal);
      const promises = [productsPromise, productTestsPromise/*, auditsPromise*/];
      Promise.all(promises).then(resp => {
        setOptions(resp[0].map(product => (
          {
            ...product,
            label: `${product.name} (${product.productNumber}) ${(!laboratoryId && isThereMutlipleProduct(product, resp[0])) ? product.laboratoryName : ''}`
          }
        )), setProductOptions, productOptions);
        setOptions(resp[1].map(r => {
          return r.productTestLaboDetails.map(productTestLaboDetail => ({
            ...productTestLaboDetail,
            label: `${r.testNumber}, ${productTestLaboDetail.laboratoryName} (${productTestLaboDetail.laboratoryNumber}), ${productTestLaboDetail.productTestLaboDetailsStatusTrad}`
          }));
        }).flat(), setProductTestOptions, productTestOptions);
        // setOptions(resp[2].map(r => (
        //   {
        //     ...r,
        //     label: `${r.name} (${r.productNumber})`
        //   }
        // )), setAuditOptions, auditOptions);
        setIsLoading(false);
      }).catch(errorMessage => {
        if (errorMessage !== ErrorName.ABORT_ERROR) {
          showDialog({
            variant: DialogType.ERROR,
            title: localize('error'),
            description: errorMessage
          });
          history.push(GENERATE_ROUTE(ROUTES.ERROR), { errorMessage: errorMessage });
        }
      });
    }
  }

  useEffect(() =>{
    const options = {};
    options.productOption = [...productOptions];
    options.productTestOption = [...productTestOptions];
    //options.auditOption = [...auditOptions];
    setItemOptions(options)
  }, [productOptions, productTestOptions/*, auditOptions*/])

  return (
    <Grid
      alignItems='center'
      className={classes.container}
      container
      justifyContent='flex-end'
    >
      <IconButton className={classes.closeIcon} onClick={() => setDisplaySearch(false)}>
        <CustomIcon
          color={theme.palette.primary.light}
          icon={faTimes}
          size="xs"
        />
      </IconButton>
      <Grid
        item
      >
        <AutoCompleteWithCategories
          autofocus={true}
          className={classes.searchBar}
          isLoading={isLoading}
          label="searchBar"
          onChange={handleSelectItem}
          onChangeTextField={handleChangeTextField}
          options={itemOptions}
          searchString={searchString}
          value={selectedItem}
        />
      </Grid>
    </Grid>
  );
};

export default SearchBar;